/**
 * @author Artem Lytvynov
 * @copyright Artem Lytvynov
 * @license Apache-2.0
 */

export enum ORDER_VALUES {
  ASC = "asc",
  DESC = "desc",
}
